import * as Sentry from '@sentry/browser';

const config = window.config;

process.env.NODE_ENV === 'production' &&
  Sentry.init({
    dsn: config.sentry?.DSN || config.sentryDSN,
    ignoreErrors: [
      `TypeError: Cannot use 'in' operator to search for 'Symbol(@@redux-worker/action)' in /home`,
      `TypeError: Cannot use 'in' operator to search for 'Symbol(@@redux-worker/action)' in /`,
    ],
    environment: config.nodeEnv,
    integrations: (defaults) =>
      config.sentry?.tracing
        ? defaults.concat([Sentry.browserTracingIntegration()])
        : defaults,
    tracesSampleRate: 1.0,
  });
